<template>
	<a v-if="link" :href="link">
		<img class="entrance_banner_image" :src="thumbnail(image)" width="420" height="124" alt="">
	</a>
	<img class="entrance_banner_image" v-else :src="thumbnail(image)" width="420" height="124" alt="">
</template>

<script>
export default {
	props: ['image', 'link'],
	methods: {
		thumbnail(imageUrl) {
			return imageUrl.match(/sandbox\.kakaocdn\.net/)
					? `//img1-sandbox.kakaocdn.net/thumb/C840x248/?fname=${encodeURIComponent(imageUrl)}`
					: `//img1.daumcdn.net/thumb/C678x200/?fname=${encodeURIComponent(imageUrl)}`;
		}
	}
}
</script>
